import {MONTH_FORMAT} from 'consts'
import {ReactComponent as LeftIcon} from 'icons/left.svg'
import {ReactComponent as RightIcon} from 'icons/right.svg'
import moment from 'moment'
import {useCallback} from 'react'
import {Selector} from './Selector'

type Props = {
  month: string
  setMonth: React.Dispatch<React.SetStateAction<string>>
}

export const MonthSelector = ({month, setMonth}: Props) => {
  const now = moment()

  const back = useCallback(() => {
    setMonth(moment(month).subtract(1, 'month').format(MONTH_FORMAT))
  }, [month, setMonth])

  const forward = useCallback(() => {
    setMonth(moment(month).add(1, 'month').format(MONTH_FORMAT))
  }, [month, setMonth])

  return (
    <div className="flex justify-between items-center">
      {moment(month).subtract(1, 'month').isBefore(moment(now).startOf('month')) ? (
        <div className="h-6 min-w-6" />
      ) : (
        <LeftIcon onClick={back} className="cursor-pointer hover:text-theme" />
      )}
      <div className="flex gap-2">
        <Selector
          initiator={<div className="font-bold cursor-pointer hover:opacity-80">{moment(month).format('MMMM')}</div>}
          list={(close) => {
            return (
              <div className="flex flex-col">
                {moment.months().map((month) => {
                  return (
                    <div
                      key={month}
                      className="font-bold cursor-pointer py-2"
                      onClick={() => {
                        setMonth(moment(month).month(month).format(MONTH_FORMAT))
                        close()
                      }}
                    >
                      {month}
                    </div>
                  )
                })}
              </div>
            )
          }}
        />

        <Selector
          initiator={<div className="font-bold cursor-pointer hover:opacity-80">{moment(month).format('YYYY')}</div>}
          list={(close) => {
            return (
              <div className="flex flex-col">
                {[now.year(), now.year() + 1, now.year() + 2].map((year) => {
                  return (
                    <div
                      key={year}
                      className="font-bold cursor-pointer py-2"
                      onClick={() => {
                        setMonth(moment(month).year(year).format(MONTH_FORMAT))
                        close()
                      }}
                    >
                      {year}
                    </div>
                  )
                })}
              </div>
            )
          }}
        />
      </div>
      <RightIcon onClick={forward} className="cursor-pointer hover:text-theme" />
    </div>
  )
}
